module.exports = __webpack_public_path__ + "static/media/oakmont-logo-linen.5a356650.svg";